export const LISTING_TITLE_ZINDEX = 10;
export const STICKY_CONTAINER_Z_INDEX = 9;

export const FILTERS_LS_NAME = 'currentAppliedFilters';
export const TITLE_HEIGHT = 45; //height 25 padding 20

export enum STICKY_VALUES {
  NONE,
  TITLE,
  BOTH,
}

export const SORT_CONTAINER_WIDTH = 295;

export enum SCROLLED_ELEMENT {
  PLACEHOLDER,
  PAGEIO,
}
